/* MIIUA Collections smooth auto rotation, preloaded double-buffer 2-second interval. */
(function(){
  'use strict';
  function init(){
    var root=document.getElementById('miiua-collections-hub');
    if(!root)return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-miiua-photo-card]:not([data-miiua-ready])'),function(box){
      var img=box.querySelector('.miiua-hub-current-image');
      var data=Array.prototype.slice.call(box.querySelectorAll('[data-miiua-src]'));
      if(!img||data.length<2)return;
      var link=box.querySelector('.miiua-hub-image-link');
      if(!link)return;
      box.setAttribute('data-miiua-ready','true');
      var counter=box.querySelector('[data-miiua-counter]');
      var reduced=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var current=0,locked=false,busy=false,showing=true;
      var cache={};
      var nextImg=img.cloneNode(false);
      nextImg.removeAttribute('loading');
      nextImg.removeAttribute('srcset');
      nextImg.removeAttribute('sizes');
      nextImg.className='miiua-hub-next-image';
      nextImg.alt='';
      nextImg.setAttribute('aria-hidden','true');
      link.appendChild(nextImg);
      function updateCount(){if(counter)counter.textContent=(current+1)+' / '+data.length+(locked?' · COLOUR':' · AUTO 2S');}
      function getSrc(i){return data[i].getAttribute('data-miiua-src');}
      function preload(i){
        var src=getSrc(i);
        if(cache[src])return cache[src];
        cache[src]=new Promise(function(resolve){
          var p=new Image();
          p.onload=function(){resolve(true);};
          p.onerror=function(){resolve(false);};
          p.src=src;
          if(p.complete&&p.naturalWidth)resolve(true);
        });
        return cache[src];
      }
      function resetSwatches(){Array.prototype.forEach.call(box.querySelectorAll('[data-miiua-pick]'),function(el){el.setAttribute('aria-pressed','false');});}
      async function show(i){
        if(busy||i===current||!data[i])return;
        busy=true;
        var ok=await preload(i);
        if(!ok){busy=false;return;}
        var src=getSrc(i),alt=data[i].getAttribute('data-miiua-alt')||img.alt;
        try {
          // Keep the current photo fully opaque until the replacement is decoded.
          nextImg.style.transition='none';
          nextImg.style.opacity='0';
          nextImg.style.transform='none';
          nextImg.src=src;
          nextImg.alt=alt;
          if(nextImg.decode){try{await nextImg.decode();}catch(e){}}
          // Bring the decoded replacement over the original. Never fade the base out.
          await new Promise(function(resolve){requestAnimationFrame(function(){requestAnimationFrame(resolve);});});
          nextImg.style.transition=reduced?'none':'opacity .5s ease-in-out';
          nextImg.style.opacity='1';
          await new Promise(function(resolve){setTimeout(resolve,reduced?20:540);});
          // Update the base underneath the fully visible overlay, and wait for decode.
          img.src=src;
          img.alt=alt;
          img.style.opacity='1';
          img.style.transform='none';
          if(img.decode){try{await img.decode();}catch(e){}}
          // Remove the overlay instantly only after the base has the same decoded image.
          nextImg.style.transition='none';
          nextImg.style.opacity='0';
          current=i;
          updateCount();
          preload((current+1)%data.length);
        } finally {busy=false;}
      }
      function next(){show((current+1)%data.length);}
      // Cache the upcoming images ahead of each change.
      preload(0);
      preload(1);
      Array.prototype.forEach.call(box.querySelectorAll('[data-miiua-pick]'),function(button){
        button.addEventListener('click',function(e){
          e.preventDefault();
          var chosen=button.getAttribute('aria-pressed')==='true';
          resetSwatches();
          if(chosen){locked=false;updateCount();return;}
          var colour=button.getAttribute('data-miiua-pick');
          var index=data.findIndex(function(item){return item.getAttribute('data-miiua-color')===colour;});
          if(index>=0){locked=true;button.setAttribute('aria-pressed','true');show(index);}
          updateCount();
        });
      });
      var touchStart=null;
      box.addEventListener('touchstart',function(e){if(e.touches.length===1)touchStart=e.touches[0].clientX;},{passive:true});
      box.addEventListener('touchend',function(e){
        if(touchStart===null)return;
        var delta=e.changedTouches[0].clientX-touchStart;
        touchStart=null;
        if(Math.abs(delta)>40){locked=false;resetSwatches();show((current+(delta<0?1:data.length-1))%data.length);}
      },{passive:true});
      updateCount();
      // Always advance, including phones with reduce-motion enabled. In that mode only the transition is simplified.
      setInterval(function(){if(!locked&&!busy&&document.visibilityState!=='hidden')next();},2000);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',init);
})();